export default "__VITE_ASSET__DfuAgd90__"